import PublicRecordsManager from '@/manager/3.6/PublicRecordsManager';
import IFeedData from '@/models/comp/IFeedData';
import CompDataFeedsRequest from '../../3.6/models/CompDataFeedsRequest';

export default {
    /**
     * Fetches public records within the store. Currently delegates to the PublicRecordsManager.
     * The dependency order between managers and stores is currently backward on this.
     * Store helpers are placeholders for backward dependency order situations and will go away
     * when we correct it, refactoring the business logic out of the store.
     * @param feedsRequest
     * @returns
     */
    async fetch(feedsRequest: CompDataFeedsRequest): Promise<IFeedData | null> {
        const feedData = await PublicRecordsManager.fetch(feedsRequest.address, feedsRequest.isSubject, feedsRequest.formCode);
        return feedData;
    },
};
